
function getToken (name) {
    const selector = 'meta[name="' + name + '"]';
    const csrfMetaTag = document.querySelector(selector);

    if (csrfMetaTag && csrfMetaTag.content) {
        return csrfMetaTag.content;
    } else {
        console.error('CSRF token meta tag not found. Add <meta name="' + name + '" content="<?= csrf_hash() ?>"> to your HTML head.');

        return '';
    }
}
function setToken (name, token) {
    const selector = 'meta[name="' + name + '"]';
    const csrfMetaTag = document.querySelector(selector);
    const oldToken = getToken(name);

    if (oldToken !== token) {
        csrfMetaTag.setAttribute('content', token);
    }
}
// function sendRequest(url, options = {}) {
//     const token_name = 'Request-Token';
//     const csrf_test_name = getToken(token_name);
//     // Prepare default headers
//     const defaultHeaders = {
//         // "Content-Type": "application/json",
//         // "X-Requested-With": "XMLHttpRequest",
//         "Request-Token": csrf_test_name
//     };
//
//     // Merge default headers with user-provided headers
//     options.headers = {
//         ...defaultHeaders,
//         ...(options.headers || {})
//     };
//
//     // Check if native fetch exists
//     if (typeof fetch === 'function') {
//         return fetch(url, options);
//     }
//
//     // Fallback to XMLHttpRequest
//     return new Promise((resolve, reject) => {
//         const xhr = new XMLHttpRequest();
//
//         // Set method, defaults to GET
//         const method = (options.method || 'GET').toUpperCase();
//
//         // Handle timeout
//         xhr.timeout = options.timeout || 0;
//
//         // Open request
//         xhr.open(method, url, true);
//
//         // Set headers (now includes CSRF token and default headers)
//         if (options.headers) {
//             Object.entries(options.headers).forEach(([key, value]) => {
//                 xhr.setRequestHeader(key, value);
//             });
//         }
//
//         // Set credentials
//         if (options.credentials === 'include') {
//             xhr.withCredentials = true;
//         }
//
//         // Handle response
//         xhr.onload = () => {
//             const response = {
//                 ok: xhr.status >= 200 && xhr.status < 300,
//                 status: xhr.status,
//                 statusText: xhr.statusText,
//                 headers: xhr.getAllResponseHeaders().split('\r\n').reduce((acc, current) => {
//                     const [name, value] = current.split(': ');
//                     if (name) acc[name.toLowerCase()] = value;
//                     return acc;
//                 }, {}),
//                 url,
//                 text: () => Promise.resolve(xhr.responseText),
//                 json: () => Promise.resolve(JSON.parse(xhr.responseText)),
//                 blob: () => Promise.resolve(new Blob([xhr.response])),
//             };
//
//             resolve(response);
//         };
//
//         // Handle errors
//         xhr.onerror = () => {
//             reject(new TypeError('Network request failed'));
//         };
//
//         xhr.ontimeout = () => {
//             reject(new TypeError('Network request timed out'));
//         };
//
//         // Send request
//         const body = options.body;
//         if (body && typeof body === 'object' && !(body instanceof FormData)) {
//             // JSON is already set in default headers, just stringify the body
//             xhr.send(JSON.stringify(body));
//         } else {
//             xhr.send(body);
//         }
//     });
// }

// function sendRequestAndSaveToken(url, options = {}) {
//     const token_name = 'Request-Token';
//
//     return sendRequest(url, options)
//         .then(res => res.json())
//         .then(response => {
//             // Extract new token from response headers
//             if (response && response.headers) {
//                 const newToken = response.headers['request-token'] ||
//                     response.headers[token_name.toLowerCase()];
//
//                 if (newToken) {
//                     setToken(token_name, newToken);
//                 }
//             }
//
//             return response;
//         });
// }
function sendRequest(url, options = {}) {
    if (typeof fetch === 'function') {
        return fetch(url, options);
    }

    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const method = (options.method || 'GET').toUpperCase();

        xhr.timeout = options.timeout || 0;
        xhr.open(method, url, true);

        if (options.headers) {
            Object.entries(options.headers).forEach(([key, value]) => {
                xhr.setRequestHeader(key, value);
            });
        }

        if (options.credentials === 'include') {
            xhr.withCredentials = true;
        }

        xhr.onload = () => {
            const response = {
                ok: xhr.status >= 200 && xhr.status < 300,
                status: xhr.status,
                statusText: xhr.statusText,
                headers: xhr.getAllResponseHeaders().split('\r\n').reduce((acc, current) => {
                    const [name, value] = current.split(': ');
                    if (name) acc[name.toLowerCase()] = value;
                    return acc;
                }, {}),
                url,
                text: () => Promise.resolve(xhr.responseText),
                json: () => Promise.resolve(JSON.parse(xhr.responseText)),
                blob: () => Promise.resolve(new Blob([xhr.response])),
            };

            resolve(response);
        };

        xhr.onerror = () => reject(new TypeError('Network request failed'));
        xhr.ontimeout = () => reject(new TypeError('Network request timed out'));

        const body = options.body;
        if (body && typeof body === 'object' && !(body instanceof FormData)) {
            xhr.send(JSON.stringify(body));
        } else {
            xhr.send(body);
        }
    });
}

function sendRequestAndSaveToken(url, options = {}) {
    const token_name = 'Request-Token';

    options.headers = {
        [token_name]: getToken(token_name),
        ...(options.headers || {}),
    };

    return sendRequest(url, options)
        .then(res => {
            let newToken = null;

            if (typeof res.headers?.get === 'function') {
                newToken = res.headers.get(token_name);
            } else if (res.headers && typeof res.headers === 'object') {
                newToken = res.headers[token_name.toLowerCase()];
            }

            if (newToken) {
                setToken(token_name, newToken);
            }

            return res.json();
        });
}
function getItiPhoneWithDialCode (input) {
    const { value } = input
    const dialWrapper = input.parentElement.firstElementChild.firstElementChild;
    const dialCode = dialWrapper ? dialWrapper.children[1].textContent : '';

    return dialCode + value;
}
function disableScroll() {
    const pagePosition = window.scrollY.toString()
    const body = document.body

    body.classList.add('disable-scroll');
    body.dataset['position'] = pagePosition;
    body.style.top = `-${pagePosition}px`;

}
function enableScroll() {
    const body = document.body
    const pagePosition =  parseInt(body.dataset.position, 10);

    body.classList.remove('disable-scroll');
    body.style.top =  'auto';
    window.scroll({ top: pagePosition, left: 0 });
    body.removeAttribute('data-position');
}
function getAge (dateString) {
    const  today = new Date();
    const  birthDate = new Date(dateString.split('.').reverse().join('-'));
    const m = today.getMonth() - birthDate.getMonth();
    let age = today.getFullYear() - birthDate.getFullYear();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
}
function addClassToElement(element, className, modifier = '') {
    if (element && !element.classList.contains(className + modifier)) {
        element.classList.add(className + modifier);
    }
}
function removeClassFromElement(element, className, modifier = '') {
    if (element && element.classList.contains(className + modifier)) {
        element.classList.remove(className + modifier);
    }
}
function setDynamicError(input, datasetKeyName, wrapper = null) {
    const errorText = input.getAttribute(datasetKeyName);

    if (!errorText) {
        return;
    }

    if (wrapper) {
        input = wrapper
    }

    input.nextElementSibling.textContent = errorText;
}
function validateInput(input) {
    const { value, name, checked } = input;
    const [ typeName, fieldName ] = name.split('_');
    const isValid = true;
    const cardExpireRegExp = /^\d{2}\/\d{2}$/;
    const cardRegExp = /^\d{4} \d{4} \d{4}$/;
    const cyrillicRegExp = /[^А-яЁёІієЄЇїЬьЪъ0-9]+$/g;
    const universalFullNameRegexp = /^[\p{L}\p{M}\p{N}_-]{1}[\p{L}\p{M}\p{N}_-]* [\p{L}\p{M}\p{N}_-]{1}[\p{L}\p{M}\p{N}_-]*$/u;
    const emailRegexp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const birthdayRegexp = /^\d{2}\.\d{2}\.\d{4}$/;

    switch (fieldName || name) {
        // case 'date':
        //     if (!value) {
        //         return false;
        //     }
        //     regExp = /^\d{2}\.\d{2}\.\d{4} - \d{2}\.\d{2}\.\d{4}$/;
        //     if (!regExp.test(value)) {
        //         return false;
        //     }
        //     const [startDate, endDate] = value.split(' - ')
        //         .map(date => normalizeDate(date));
        //     const d = new Date();
        //     const currentDate = [
        //         d.getFullYear(),
        //         d.getMonth() + 1,
        //         d.getDate()
        //     ].map(n => n < 10 ? `0${n}` : n).join('-');
        //     if (startDate < currentDate) {
        //         return false;
        //     }
        //     if (startDate > endDate) {
        //         return false;
        //     }
        //     return isValid;
        case 'expire':
            if (!cardExpireRegExp.test(value)) {
                return false;
            }
            return isValid;
        case 'cvv':
            if (!/^\d{3,4}$/.test(value)) {
                return false;
            }
            return isValid;
        case 'type':
        case 'territory':
            if (!value) {
                return false;
            }
            // const list = getListElements(input);
            //
            // for (const listElement of list) {
            //     if (listElement.firstElementChild.textContent === value) {
            //         return true;
            //     }
            // }

            return true;
        case 'number':
            if (typeName === 'card' && !cardRegExp.test(value)) {
                return false;
            } else if (typeName === 'policy' && value.length < 5) {
                return false;
            }

            return isValid;
        case 'isConfirmed':
            if (!checked) {
                return false;
            }
            return isValid;
        case 'birthday':
            const minAgeLimit = typeName === 'insurer' ? 16 : 1;
            const { months , years} = getAgeWithMonths(value);
            const maxAgeLimit = 200;
            const age = getAge(value);
            const wrapper = input.parentElement;

            if (isNaN(age) || isNaN(months) || isNaN(years)) {
                return false;
            }

            if (!value || !birthdayRegexp.test(value) || age > maxAgeLimit) {
                setDynamicError(input, 'data-error-required', wrapper);

                return false;
            }

            if (typeName === 'insurer' &&  age < minAgeLimit) {
                setDynamicError(input, 'data-error', wrapper);

                return false;

            }

            if (typeName === 'tourist' && years === 0 && months < 2) {
                setDynamicError(input, 'data-error', wrapper);

                return false;

            }

            // if (age < minAgeLimit) {
            //     setDynamicError(input, 'data-error', wrapper);
            //
            //     return false;
            // }

            return isValid;
        case 'name':
            if (!value) {
                setDynamicError(input, 'data-error-required');

                return false;
            }

            if (typeName !== 'full' && value.search(cyrillicRegExp) !== 0) {
                setDynamicError(input, 'data-error');

                return false;
            }

            if (typeName === 'full' && !universalFullNameRegexp.test(value)) {
                return false;
            }

            return isValid;
        case 'lastname':
            if (!value) {
                setDynamicError(input, 'data-error-required');

                return false;
            }

            if (value.search(cyrillicRegExp) !== 0) {
                setDynamicError(input, 'data-error');

                return false;
            }

            return isValid;
        case 'passport':
            if (!value || value.length < 5) {
                return false;
            }

            return isValid;
        case 'phone':
        case 'message':
            if (!value || value.length < 5) {
                return false;
            }

            return isValid;
        case 'email':
            if (!emailRegexp.test(value)) {
                return false;
            }

            return isValid;
        default:
            return isValid;
    }
}

function getAgeWithMonths(date) {
    const today = new Date();
    const dob = new Date(date.split('.').reverse().join('-'));

    let years = today.getFullYear() - dob.getFullYear();
    let months = today.getMonth() - dob.getMonth();
    let days = today.getDate() - dob.getDate();

    // Если день рождения в этом месяце ещё не наступил
    if (days < 0) {
        months -= 1;
    }

    // Если месяц ещё не наступил
    if (months < 0) {
        years -= 1;
        months += 12;
    }

    return {
        years: years,
        months: months
    };
}
function validateForm (form, ...inputs) {
    const { elements } = form;
    const errorFields = [];
    const errorInputs = [];
    const body = {};

    for (const input of elements) {
        const { name, checked, type, dataset } = input;
        let { value } = input;

        if (!name) {
            continue;
        }

        const isValid = validateInput(input);

        switch (type) {
            case 'tel':
                value = getItiPhoneWithDialCode(input);
                break;
            case 'checkbox':
                value = checked;
                break;
        }

        body[name] = value;

        if (dataset.value) {
            body[name + '_id'] = dataset.value;
        }

        if (isValid) {
            continue;
        }

        if (inputs.includes(name) || !inputs.length) {
            errorFields.push(name);
            errorInputs.push(input);
        }
    }

    body.isValid = !errorFields.length;
    body.errorFields = errorFields;
    body.errorInputs = errorInputs;

    return body;
}
function savePlaceholder (input) {
    const placeholder = input.getAttribute('placeholder');

    if (placeholder) {
        input.dataset['placeholder'] = placeholder;
    }
}
function checkInput ({ groupClass }) {
    const modifier = '--error'

    return (e) => {
        const { target } = e;
        const isValid = validateInput(target);

        if (!isValid) {
            addClassToElement(target.closest('.' + groupClass), groupClass, modifier);
        }
    }
}
function hideError ({ groupClass }) {
    const modifier = '--error'

    return ({ target }) => removeClassFromElement(target.closest('.' + groupClass), groupClass, modifier);
}
function showSuccess ({ groupClass }) {
    const modifier = '--success';

    return ({ target }) => addClassToElement(target.closest('.' + groupClass), groupClass, modifier);
}
function hideSuccess ({ groupClass }) {
    const modifier = '--success'

    return ({ target }) => removeClassFromElement(target.closest('.' + groupClass), groupClass, modifier);
}
function showPlaceholder (e) {
    const { target } = e;
    const { value, dataset } = target;

    if (value) {
        return;
    }

    target.setAttribute('placeholder', dataset['placeholder'] || '');
}
function hidePlaceholder (e) {
    const { target } = e;

    if (!target.value) {
        target.setAttribute('placeholder', '');
    }
}
function showModal ({ closeButtonClass, modalContentClass, visibleClass, modalWrapperClass }) {
    const listener = (e) => {
        const { target } = e
        const button = target.closest('.' + closeButtonClass);
        const modal = target.closest('.' + modalContentClass);
        const modalWrapper = target.closest('.' + modalWrapperClass);

        if ((button || !modal) && modalWrapper) {
            modalWrapper.classList.remove(visibleClass);
            enableScroll();
        }
    }
    const listeners = {};

    return (modalId) => {
        const loaderId = 'loader-modal';
        const modal = document.getElementById(modalId);

        if (!modal) {
            return;
        }

        disableScroll();
        modal.classList.add(visibleClass);

        if (modalId === loaderId || listeners[modalId]) {
            return;
        }

        modal.addEventListener('click', listener);
        listeners[modalId] = true;
    }
}
function hideModal({ visibleClass, modalWrapperClass }) {
    return (e) => {
        const { target } = e;
        const modalWrapper = target.closest('.' + modalWrapperClass);

        if (modalWrapper) {
            modalWrapper.classList.remove(visibleClass);
            enableScroll();
        }
    }
}
function toggleMenu ({ triggerClass, contentClass }, closeMenusCb = () => {}) {
    const modifier = '--active';

    return (e) => {
        const { target } = e;
        const link = target.closest('a');
        const menuTrigger = target.closest('.' + triggerClass);
        const menuContent = target.closest('.' + contentClass);

        if (link || !menuTrigger || menuContent) {
            return;
        }

        const isActive = menuTrigger.classList.contains(triggerClass + modifier)

        closeMenusCb(target);

        if (!isActive) {
            menuTrigger.classList.add(triggerClass + modifier);
        }

        if (!contentClass) {
            return;
        }

        const isLast = menuTrigger.lastElementChild.classList.contains(contentClass)
        const menu = isLast ? menuTrigger.lastElementChild : menuTrigger.nextElementSibling


        if (!menu.classList.contains(contentClass) || isActive) {
            return;
        }

        menu.classList.add(contentClass + modifier);
    }
}
function closeMenus (menus, modifier = '--active') {
    return () => {
        for (const prop in menus) {
            const { triggerClass, contentClass } = menus[prop];
            const activeMenuTriggers = document
                .getElementsByClassName(triggerClass + modifier)
            const activeMenuContents = document
                .getElementsByClassName(contentClass + modifier)

            if (activeMenuTriggers.length) {
                for (const activeMenuTrigger of activeMenuTriggers) {
                    activeMenuTrigger.classList.remove(triggerClass + modifier);
                }
            }

            if (activeMenuContents.length) {
                for (const activeMenuContent of activeMenuContents) {
                    activeMenuContent.classList.remove(contentClass + modifier);
                }
            }
        }
    }
}
function toggleTab ({ triggerClass, contentClass }) {
    const modifier = '--active';
    const animatedTabs = [
        'faq__card-answer',
    ];

    return (e) => {
        const { target } = e;
        const link = target.closest('a');
        const menuTrigger = target.closest('.' + triggerClass);
        const menuContent = target.closest('.' + contentClass);

        if (link || !menuTrigger || menuContent) {
            return;
        }

        menuTrigger.classList.toggle(triggerClass + modifier);

        if (!contentClass) {
            return;
        }

        const isLast = menuTrigger.lastElementChild.classList.contains(contentClass)
        const menu = isLast ? menuTrigger.lastElementChild : menuTrigger.nextElementSibling


        if (!menu.classList.contains(contentClass)) {
            return;
        }

        menu.classList.toggle(contentClass + modifier);

        if (!animatedTabs.includes(contentClass)) {
            return;
        }

        if (menu.classList.contains(contentClass + modifier)) {
            menu.setAttribute('aria-hidden', false);
            menu.style.maxHeight = menu.scrollHeight + 'px';
        } else {
            menu.setAttribute('aria-hidden', true);
            menu.style.maxHeight = null;
        }

    }
}
function toggleMore ({ triggerClass, hideContentClass, showedListLength }) {
    const modifier = '--active'

    return (e) => {
        const { target } = e
        const moreTrigger = target.closest('.' + triggerClass);

        if (!moreTrigger) {
            return;
        }

        const isActive = moreTrigger.classList.contains(triggerClass + modifier);
        const lis = Array.from(moreTrigger.previousElementSibling.children);

        moreTrigger.classList.toggle(triggerClass + modifier);

        lis.forEach((li, idx) => {
            removeClassFromElement(li, hideContentClass);

            if (isActive && idx >= showedListLength && showedListLength >= 0) {
                li.classList.add(hideContentClass);
            }
        })
    }
}
function scrollToElement (element, speed, offset = 0) {
    if (!element || typeof speed !== 'number' || speed <= 0) {
        return;
    }

    const targetPosition = element.getBoundingClientRect().top + window.pageYOffset + offset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = speed;
    let startTime = null;

    function animation(currentTime) {
        if (startTime === null) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const run = easeInOutQuad(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);

        if (timeElapsed < duration) {
            requestAnimationFrame(animation);
        } else {
            window.scrollTo(0, targetPosition); // Ensure exact positioning at the end
        }
    }

    function easeInOutQuad(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t + b;
        t--;
        return -c / 2 * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(animation);
}
function createAnchorClickHandler (actions) {
    return (e) => {
        const { dataset, tagName } = e.target;

        if (tagName !== 'A') {
            return;
        }

        let isActionExists = false;

        for (const action in actions) {
            if (dataset.hasOwnProperty(action)) {
                isActionExists = true;
                actions[action](dataset);
            }
        }

        if (isActionExists) {
            e.preventDefault();
        }
    }
}
function createButtonClickHandler (actions) {
    return (e) => {
        const button = e.target.closest('button[type="button"]');

        if (!button) {
            return;
        }

        const { dataset } = button;

        for (const action in actions) {
            if (dataset.hasOwnProperty(action)) {
                actions[action](dataset);
            }
        }
    }
}
function setCountryTime(date) {
    // Create a Date object if a string was passed
    const dateObj = date instanceof Date ? date : new Date(date);

    // Check if the date is valid
    if (isNaN(dateObj.getTime())) {
        return 'Invalid date';
    }

    // Get hours in 12-hour format
    let hours = dateObj.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // Convert 0 to 12 for midnight

    // Get minutes and pad with leading zero if needed
    const minutes = dateObj.getMinutes().toString().padStart(2, '0');

    // Return formatted time string
    return `${hours}:${minutes} ${ampm}`;
}
function getCountryDate(offsetUTC) {
    const now = new Date();
    const utcTime = now.getTime() + (now.getTimezoneOffset() * 60000);
    const offsetTime = utcTime + (offsetUTC * 3600000);

    return new Date(offsetTime);
}
function updateCountryTimeLabel (timeLabelElement) {
    const { offset } = timeLabelElement.dataset;

    if (offset) {
        timeLabelElement.textContent = setCountryTime(getCountryDate(parseInt(offset)));
    }
}
function  setCooperateFormHandlers () {
    const cooperateForm = document.getElementsByClassName('popup__form')[0];

    if (!cooperateForm) {
        return;
    }

    const checkInputValue = checkInput({ groupClass: 'popup__form-group' });
    const hideInputError = hideError({ groupClass: 'popup__form-group' });
    const tags = [ 'INPUT', 'TEXTAREA' ];

    for (const element of cooperateForm.elements) {
        const { tagName } = element;

        if (tags.includes(tagName)) {
            savePlaceholder(element);
            element.addEventListener('focus', hideInputError);
            element.addEventListener('focus', hidePlaceholder);
            element.addEventListener('blur', checkInputValue);
            element.addEventListener('blur', showPlaceholder);
        }
    }

    cooperateForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const body = validateForm(e.target);

        if (!body.isValid) {
            body.errorInputs.forEach(input => checkInputValue({ target: input }));

            return;
        }

        showModalById('loader-modal');
        sendRequestAndSaveToken('/api/create_cooperate_order', {
            method: 'POST', body: JSON.stringify({
                full_name: body.full_name,
                message: body.message,
                phone: body.phone,
                email: body.email,
                url: window.location.pathname || '/',
            })
        }).then(({ response }) => {
            const loader = document.getElementById('loader-modal');

            hideCurrentModal({ target: loader });
            hideCurrentModal(e);

            if (!response || !response.success) {
                showModalById('error-modal');

                return;
            }

            const { request_id, success, error_text } = response;

            // console.log({ success, error_text, request_id });

            showModalById('success-modal');
            e.target.reset();
        }).catch(e => showModalById('error-modal'));
    });
}
function  setToDirectorFormHandlers () {
    const toDirectorForm = document.getElementsByClassName('popup__form')[1];

    if (!toDirectorForm) {
        return;
    }

    const checkInputValue = checkInput({ groupClass: 'popup__form-group' });
    const hideInputError = hideError({ groupClass: 'popup__form-group' });
    const tags = [ 'INPUT', 'TEXTAREA' ];

    for (const element of toDirectorForm.elements) {
        const { tagName } = element;

        if (tags.includes(tagName)) {
            savePlaceholder(element);
            element.addEventListener('focus', hideInputError);
            element.addEventListener('focus', hidePlaceholder);
            element.addEventListener('blur', checkInputValue);
            element.addEventListener('blur', showPlaceholder);
        }
    }

    toDirectorForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        const body = validateForm(e.target);

        if (!body.isValid) {
            body.errorInputs.forEach(input => checkInputValue({ target: input }));

            return;
        }

        showModalById('loader-modal');
        sendRequestAndSaveToken('/api/create_to_director_order', {
            method: 'POST', body: JSON.stringify({
                full_name: body.full_name,
                message: body.message,
                phone: body.phone,
                email: body.email,
                url: window.location.pathname || '/',
            })
        }).then(({ response }) => {
            const loader = document.getElementById('loader-modal');

            hideCurrentModal({ target: loader });
            hideCurrentModal(e);

            if (!response || !response.success) {
                showModalById('error-modal');

                return;
            }

            // const { request_id, success, error_text } = response;

            // console.log({ success, error_text, request_id });

            showModalById('success-modal');
            e.target.reset();
        }).catch(e => showModalById('error-modal'));
    });
}
function getCountryTimeLabelElements (timeLabelClasses) {
    const countryTimeLabelElements = [];

    timeLabelClasses.forEach(className => {
        const countryTimeLabels = document.getElementsByClassName(className);

        if (!countryTimeLabels.length) {
            return;
        }

        countryTimeLabelElements.push(...countryTimeLabels);
    });

    return countryTimeLabelElements;
}
// function setCountryTimeLabelOffsetAndTime (timeLabelElements, updateViewStep = 30 * 1000) {
//     if (!timeLabelElements.length) {
//         return;
//     }
//
//     sendRequestAndSaveToken('/api/get_countries_contacts', { method: 'POST' })
//         .then(({ response }) => {
//             timeLabelElements.forEach(countryTimeLabelElement => {
//                 const { text } = countryTimeLabelElement.dataset
//
//                 if (!text) {
//                     return;
//                 }
//
//                 const countryContact = response.find(({ country }) => country === text);
//
//                 if (countryContact && countryContact.utf_offset) {
//                     countryTimeLabelElement.dataset.offset = countryContact.utf_offset.toString();
//                     countryTimeLabelElement.textContent = setCountryTime(getCountryDate(countryContact.utf_offset));
//                 }
//             });
//         }).catch(e => console.error(e.message));
//
//
//     setInterval(() => timeLabelElements.forEach(updateCountryTimeLabel), updateViewStep);
// }
function setRefreshCountryTimeInterval (updateViewStep = 30 * 1000) {
    const timeLabels = document.querySelectorAll('span[data-offset]')

    if (!timeLabels.length) {
        return;
    }

    timeLabels.forEach(updateCountryTimeLabel);
    setInterval(() => timeLabels.forEach(updateCountryTimeLabel), updateViewStep);
}

// function addGetParamsToLink(element) {
//     const path = getCurrentPath();
//     const { href } = element;
//
//     if (!path || !href) {
//        return;
//     }
//
//     element.href = href + path;
// }
//
// function addGetParamsToLanguageLinks () {
//     const getLisFromElements = (element) => element.firstElementChild.children;
//     const classNames = ['header__language-list', 'footer__language-list'];
//     const elements = classNames.reduce((acc, className) => {
//         const elements = document.getElementsByClassName(className);
//
//         if (elements && elements.length) {
//             acc.push(...elements);
//         }
//
//         return acc;
//     }, []);
//     const lis = elements.reduce((acc, element) => {
//         acc.push(...getLisFromElements(element));
//
//         return acc;
//     }, []);
//
//     lis.forEach(li => {
//         const anchor = li.firstElementChild;
//
//         if (anchor) {
//             addGetParamsToLink(anchor);
//         }
//     });
// }

// function setLanguagesAndLinks (languageListElements) {
//     const path = getCurrentPath();
//     const createLanguageList = (languages, id = null) => {
//         const flagsPath = '/img/flags/';
//         const imageExtension = '.svg';
//
//         return languages.map(({lang_code, text, alias}) => {
//             const li = document.createElement('li');
//             const a = document.createElement('a');
//             const img = document.createElement('img');
//             const spanText = document.createElement('span');
//             // const spanAlias = document.createElement('span');
//
//             img.setAttribute('src', flagsPath + alias + imageExtension);
//             img.setAttribute('alt', 'Flag icon');
//             spanText.textContent = text;
//             // spanAlias.textContent = alias;
//             a.setAttribute('href', `${lang_code}/${path}${id || ''}`);
//             // a.append(img, spanText, spanAlias);
//             a.append(img, spanText);
//             li.appendChild(a);
//
//             return li;
//         })
//     }
//
//     sendRequestAndSaveToken('/api/get_localization_languages', { method: 'GET' })
//         .then(({ response }) => {
//             if (!languageListElements || !languageListElements.length) {
//                 return;
//             }
//
//             languageListElements.forEach(listElement => {
//                 const ul = document.createElement('ul');
//                 const isFooter = listElement.closest('#footer');
//
//                 listElement.innerHTML = '';
//                 ul.append(...createLanguageList(response, isFooter ? '#footer' : null));
//                 listElement.appendChild(ul);
//             });
//         }).catch(e => console.error(e.message));
// }
function getCurrentPath() {
    // Get the current pathname and search
    const pathname = window.location.pathname;
    const search = window.location.search;
    const segments = pathname
        .replace(/^\//, '')
        .split('/');

    if (segments.length > 0 && segments[0].match(/^[a-z]{2}$/)) {
        segments.shift();
    }

    return segments.join('/') + search;
}

function getListElements (input) {
    return input.parentElement.lastElementChild.firstElementChild.children;
}

function insertScript(src, element) {
    return new Promise((resolve, reject) => {
        // Validate source
        if (!src || typeof src !== 'string') {
            reject(new Error('Invalid script source provided'));
            return;
        }

        // Determine insertion point
        const insertionPoint = element || document.head || document.body;
        if (!insertionPoint) {
            reject(new Error('No valid insertion point found'));
            return;
        }

        // Create script element
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;

        const startTime = performance.now();

        // Handle script load success
        script.onload = function() {
            resolve({
                success: true,
                src: src,
                element: script,
                insertionPoint: insertionPoint,
                loadTime: performance.now() - startTime
            });
        };

        // Handle script load failure
        script.onerror = function() {
            reject(new Error(`Failed to load script: ${src}`));
        };

        // Set source
        script.src = src;

        // Insert script
        if (element && element.nodeType) {
            // Insert after the specified element
            element.parentNode.insertBefore(script, element);
        } else {
            // Append to insertion point (head or body)
            insertionPoint.appendChild(script);
        }

        // Set timeout for script loading
        setTimeout(() => {
            if (script.readyState !== 'complete') {
                reject(new Error(`Script loading timeout: ${src}`));
            }
        }, 30000); // 30 second timeout
    });
}

function insertStyleLink(src, element) {
    return new Promise((resolve, reject) => {
        // Validate source
        if (!src || typeof src !== 'string') {
            reject(new Error('Invalid stylesheet source provided'));
            return;
        }

        // Determine insertion point
        const insertionPoint = element || document.head || document.body;
        if (!insertionPoint) {
            reject(new Error('No valid insertion point found'));
            return;
        }

        // Create link element
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.type = 'text/css';

        const startTime = performance.now();

        // Handle stylesheet load success
        link.onload = function() {
            resolve({
                success: true,
                src: src,
                element: link,
                insertionPoint: insertionPoint,
                loadTime: performance.now() - startTime
            });
        };

        // Handle stylesheet load failure
        link.onerror = function() {
            reject(new Error(`Failed to load stylesheet: ${src}`));
        };

        // Set source
        link.href = src;

        // Insert link
        if (element && element.nodeType) {
            // Insert after the specified element
            element.parentNode.insertBefore(link, element);
        } else {
            // Append to insertion point (head or body)
            insertionPoint.appendChild(link);
        }

        // Set timeout for stylesheet loading
        setTimeout(() => {
            // Check if stylesheet is loaded by testing document.styleSheets
            let isLoaded = false;
            for (let i = 0; i < document.styleSheets.length; i++) {
                if (document.styleSheets[i].href === link.href) {
                    isLoaded = true;
                    break;
                }
            }

            if (!isLoaded) {
                reject(new Error(`Stylesheet loading timeout: ${src}`));
            }
        }, 30000); // 30 second timeout
    });
}

function runOnce(cb) {
    // Validate callback
    if (typeof cb !== 'function') {
        throw new Error('Callback must be a function');
    }

    let hasRun = false;
    let result;

    return function(...args) {
        if (hasRun) {
            return result;
        }

        hasRun = true;
        result = cb.apply(this, args);
        return result;
    };
}

function loadGoogleAnalytics () {
    const delay = 4500;
    const createScriptBlock = (w, d, s, l, i) => {
        w[l] = w[l] || [];
        w[l].push({"gtm.start": new Date().getTime(), event: "gtm.js"});
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
    };
    const createNoscriptBlock = (googleKey) => {
        // <noscript>
        //     <iframe
        //         src="https://www.googletagmanager.com/ns.html?id=GTM-5QXP9HC3"
        //         height="0"
        //         width="0"
        //         style="display:none;visibility:hidden"
        //     ></iframe>
        // </noscript>

        const noscript = document.createElement('noscript');
        const iframe = document.createElement('iframe');

        iframe.height = '0';
        iframe.width = '0';
        iframe.style.display = 'none';
        iframe.style.visibility = 'hidden';
        iframe.src = 'https://www.googletagmanager.com/ns.html?id=' + googleKey;
        noscript.appendChild(iframe);
        document.body.insertBefore(noscript, document.body.firstChild);
    }

    const loadAnalyticsOnce = runOnce(() => {
        // const googleKeys = ['GTM-5QXP9HC3', 'GTM-P866ZPC'];
        //
        // googleKeys.forEach(googleKey => {
        //     createScriptBlock(window, document, "script", "dataLayer", googleKey);
        //     createNoscriptBlock(googleKey);
        // })
        createScriptBlock(window, document, "script", "dataLayer", 'GTM-5QXP9HC3');
        createNoscriptBlock('GTM-5QXP9HC3');
    });

    setTimeout(() => {
        sendRequestAndSaveToken('/api/update_session_details', {method: "POST", body: JSON.stringify({})})
    }, 5000)

    setTimeout(loadAnalyticsOnce, delay);
    window.addEventListener('click', loadAnalyticsOnce, { once: true });
    window.addEventListener('scroll', loadAnalyticsOnce, { once: true });
    window.addEventListener('mousemove', loadAnalyticsOnce, { once: true });
    window.addEventListener('touchstart', loadAnalyticsOnce, { once: true });
}
function setHumanCookie (){
    document.cookie = "human_visited=1; max-age=2592000; path=/; SameSite=Lax;";
}

function isHumanCookieExists () {
    return document.cookie.includes('human_visited=1');
}
function saveSessionDetails() {
    const events = ['click', 'scroll', 'touchstart', 'mousemove', 'keydown', 'pointerdown', 'focus'];
    const saveOnce = runOnce(() => {
        const body = {
            referrer: document.referrer,
            url: window.location.pathname + window.location.search,
            locale: labels.locale,
            get_params: Object.fromEntries(new URLSearchParams(window.location.search)),
        }
        sendRequestAndSaveToken('/api/save_session_details', {
            method: "POST",
            body: JSON.stringify(body),
        })
    });

    events.forEach(e => window.addEventListener(e, saveOnce, { once: true }));
    document.addEventListener('visibilitychange', saveOnce, { once: true });
}

function removePreviewAndLoadSwiperStyles () {
    const swiperWrappers = Array.from(document.querySelectorAll('*[data-class-names="swiper-wrapper"]'));

    swiperWrappers.forEach(swiperWrapper => {
        swiperWrapper.style.display = '';
        swiperWrapper.style.position = '';
        swiperWrapper.style.flexWrap = '';
        swiperWrapper.style.justifyContent = '';
    })

    const swiperElemets = Array.from(document.querySelectorAll('*[data-class-names]'));

    swiperElemets.forEach(addClassNamesFromDataset);

    const slidePreviewClass = 'slide-preview';
    const slideElements = Array.from(document.getElementsByClassName(slidePreviewClass));

    slideElements.forEach(element => removeClassFromElement(element, slidePreviewClass));
}

function addClassNamesFromDataset (element) {
    const separator = ' ';
    const { classNames } = element.dataset;

    if (!classNames) {
        return;
    }

    element.classList.add(...classNames.split(separator));
}

(function () {
    const TOKEN_REFRESH_INTERVAL = 10 * 60 * 1000; // 10 minutes

    !isHumanCookieExists() && setHumanCookie();
    setInterval(function () {
        sendRequestAndSaveToken('/api/refresh_token');
    }, TOKEN_REFRESH_INTERVAL);
})();

document.addEventListener('DOMContentLoaded', function() {
    const images = document.querySelectorAll('img[loading="lazy"]');

    isHumanCookieExists() && saveSessionDetails();

    if ('loading' in HTMLImageElement.prototype) {
        // Browser supports native lazy loading
        return;
    }

    // Fallback for older browsers
    const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const img = entry.target;
                img.src = img.dataset.src;
                imageObserver.unobserve(img);
            }
        });
    });

    images.forEach(img => imageObserver.observe(img));
});

function getCountryCode() {
    const GEO_CACHE_KEY = 'cached_country_code';
    const GEO_CACHE_TTL = 7 * 24 * 60 * 60 * 1000;
    const DEFAULT_COUNTRY_CODE = 'us';

    try {
        const cached = localStorage.getItem(GEO_CACHE_KEY);

        if (cached) {
            const { code, timestamp } = JSON.parse(cached);

            if (Date.now() - timestamp < GEO_CACHE_TTL) {
                return Promise.resolve(code.toLowerCase());
            }
        }
    } catch (e) {}

    return sendRequest("https://ipapi.co/json")
        .then(res => {
            return !res.ok ? { country_code: DEFAULT_COUNTRY_CODE } : res.json();
        })
        .then(({ country_code }) => {
            const code = (country_code || DEFAULT_COUNTRY_CODE).toLowerCase();

            try {
                localStorage.setItem(GEO_CACHE_KEY, JSON.stringify({
                    code,
                    timestamp: Date.now()
                }));
            } catch (e) {}

            return code;
        })
        .catch(() => DEFAULT_COUNTRY_CODE);
}
